import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// helper for pretty channel colors
export const CHANNEL_COLORS = {
  WhatsApp: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Instagram DM": "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  "Instagram Comment": "bg-pink-50 text-pink-700 border-pink-200",
  "Phone Call": "bg-sky-50 text-sky-700 border-sky-200",
  "Walk-in": "bg-amber-50 text-amber-700 border-amber-200",
};

export const STATUS_COLORS = {
  "New Inquiry": "bg-stone-100 text-stone-700 border-stone-200",
  Quoted: "bg-amber-50 text-amber-700 border-amber-200",
  Confirmed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Payment Received": "bg-sky-50 text-sky-700 border-sky-200",
  Dispatched: "bg-violet-50 text-violet-700 border-violet-200",
  Delivered: "bg-teal-50 text-teal-700 border-teal-200",
};

export const ORDER_STAGES = [
  "New Inquiry",
  "Quoted",
  "Confirmed",
  "Payment Received",
  "Dispatched",
  "Delivered",
];

export const CHANNELS = [
  "WhatsApp",
  "Instagram DM",
  "Instagram Comment",
  "Phone Call",
  "Walk-in",
];

export const INQUIRY_TYPES = [
  "Price Query",
  "Availability",
  "Customization",
  "Order Status",
  "Complaint",
  "Other",
];

export const AVAILABILITY = ["In Stock", "Sold", "Made-to-order"];

// resolve backend-hosted file paths for <img src>
export function resolveImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}
